/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';

// Hook to use the locales context
import { createContext, useContext } from 'react';
import { SupportedLocales } from './i18n';

// Context for locales management
export interface LocaleContextType {
  currentLanguage: SupportedLocales;
  changeLanguage: (language: SupportedLocales) => Promise<boolean>;
  isLoading: boolean;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

const useLocale = (): LocaleContextType => {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};

export { useLocale };

export { LocaleContext };
